/**
 * 属性画面項目クラス
 */
export class AttributeValue {
  /**
   * キー
   */
  key: string;

  /**
   * 値
   */
  value: string;

  /**
   * 基本表示項目か
   */
  isSimple: boolean;

  /**
   * 共通表示項目か
   */
  isCommon?: boolean;

  constructor(
    key: string,
    value: string,
    isSimple: boolean,
    isCommon?: boolean
  ) {
    this.key = key ?? "-";
    this.value = value || String(value) === "0" ? value : "-";
    this.isSimple = isSimple ?? false;
    this.isCommon = isCommon ?? false;
  }
}
